import { Routes, Route, Navigate } from "react-router-dom";   // ✅ no need to import BrowserRouter here
import SpiritualMarketplace from './pages/Home';
import { Contact } from "./pages/Contact";
import { useState, useEffect } from "react";


import './App.css';
import registerServiceWorker from "./registerSW.js";
import { findUrl } from "./utilities/findurl.js";

import { useDispatch, useSelector } from "react-redux";
import { fetchClientUid } from "./state/tab/clientSlice.ts";
import AgentDashboard from "./pages/agents/Dashboard.tsx";
import CustomerDashboard from "./pages/customers/Dashboard.tsx";
import AdvertismentAdminDashboard from "./pages/advertisment_admin/Dashboard.tsx";
import SuccessCheckout from "./components/successcheckout.jsx";
import { LoginModal } from "./components/ui/loginmodal.tsx";
import VcomAudioCall from "./components/ui/customers/vcomaudiocall.tsx";
import VcomAgentAudioCall from "./pages/agents/vcomagentaudiocall.tsx";
import VcomAgentVideoCall from "./pages/agents/vcomagentvideocall.tsx";
import LoginApproved from "./components/loginapproved.jsx";
import CardApproved from "./components/cardapproved.jsx";
import AgentProfilePage from "./pages/AgentDetail.tsx";
import AgentsPage from "./pages/AgentsPage.tsx";
import BlogsPage from "./pages/BlogsPage.tsx";
import BookingCardApproved from "./components/bookingcardapproved.jsx";
import VcomVideoCall from "./components/ui/customers/vcomvideocall.tsx";
import PersonvernPage from "./pages/PersonvernPage.tsx";
import VilkarPage from "./pages/VilkarPage.tsx";
import VcomAgentBookingCall from "./pages/agents/vcomagentbookingcall.tsx";
import VcomBookingCall from "./components/ui/customers/vcombookingcall.tsx";
import VilkarBookingCancelPage from "./pages/VilkarBookingCancelPage.tsx";
import EventsPage from "./pages/EventsPage.tsx";
import JoinBroadcastAgent from "./pages/agents/joinbroadcast.tsx";
import JoinBroadcastGuest from "./pages/joinbroadcast.tsx";
import BroadcastCardApproved from "./components/broadcastcardapproved.jsx";
import JoinBroadcastCustomer from "./pages/customers/joinbroadcast.tsx";
import ClientDashboard from "./pages/support_admin/Dashboard.tsx";
import PaymentMethodsPage from "./pages/PaymentMethodsPage.tsx";
import VippsBookingPage from "./pages/VippsBookingPage.tsx";
import VideoServicePage from "./pages/VideoService.tsx";
import { useLocation } from "react-router-dom";
import KYCSuccess from "./components/kycsuccess.jsx";
import { PasswordModal } from "./components/ui/passwordmodal.tsx";
import FlowPage from "./pages/FlowPage.tsx";
import AgentKYCSuccess from "./components/agentkycsuccess.jsx";
import AgentStripeReauthHandler from "./components/agentstripereauthhandler.jsx";
function App() {
  const location = useLocation();
  useEffect(() => {
    registerServiceWorker();
  }, []);

  const dispatch = useDispatch();
  const client = useSelector((state) => state.client.client);
  const footer_settings = client ? JSON.parse(client.footer_settings) : null;

  useEffect(() => {
    dispatch(fetchClientUid());
  }, [dispatch]);

  const [showLogin, setShowLogin] = useState(false);
  const [currentUser, setCurrentUser] = useState(JSON.parse(localStorage.getItem("authToken")));
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [firstLoginUser, setFirstLoginUser] = useState(null);

  const [baseUrl, setBaseUrl] = useState(findUrl());

  useEffect(() => {
    setBaseUrl(findUrl());
  }, []);

  useEffect(() => {
    if (location.hash === "#login") {
      setShowLogin(true);
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, [location]);

  useEffect(() => {
    // --- Set Page Title ---
    document.title = "Chamcore MultiTheme1";

    // --- Set Favicon Dynamically ---
    const favicon = document.querySelector("link[rel='icon']") || document.createElement("link");
    favicon.rel = "icon";
    favicon.href = baseUrl.includes("localhost") ? "https://localhost/chamcore/chameleon/uploads/clients/logo/" + footer_settings?.fav_icon : "https://chamcore.com/chameleon/uploads/clients/logo/" + footer_settings?.fav_icon; // can be .png, .svg, etc.
    document.head.appendChild(favicon);
  }, [baseUrl, footer_settings]);

  useEffect(() => {
    const stored = localStorage.getItem("authToken");
    if (stored) {
      const { token, role, expires, name } = JSON.parse(stored);
      const now = new Date().getTime();
      if (now < expires) {
        setCurrentUser({ token, role, name });
        startAutoLogout(expires - now);
      } else {
        localStorage.removeItem("authToken");
      }
    }
  }, []);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "auto";
    }
  }, []);

  const handleLoginSuccess = (token, role, name, fullResponse = null) => {

    const isFirst =
      fullResponse &&
      (role === "support" || role === "admin") &&
      fullResponse.is_first === 1;

    // ✅ If first login → open password modal
    if (isFirst) {
      setFirstLoginUser(fullResponse);
      setShowPasswordModal(true);
    }

    const expires = new Date().getTime() + (3600000 * 3);
    localStorage.setItem("authToken", JSON.stringify({ token, role, expires, name }));
    setCurrentUser({ token, role, name });
    setShowLogin(false);

    startAutoLogout(3600000 * 3);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("soundEnabled");
    localStorage.removeItem("previousPage");
    setCurrentUser(null);
  };

  const startAutoLogout = (ms) => {
    setTimeout(() => {
      handleLogout();
      alert("Session expired. You have been logged out.");
    }, ms);
  };

  const [mode, setMode] = useState('login');

  return (
    <>
      <Routes>
        <Route path="/" element={
          <SpiritualMarketplace
            onLoginClick={() => { setMode("login"); setShowLogin(true) }}
            currentUser={currentUser}
            onLogout={handleLogout}
            baseUrl={baseUrl}
            onLoginSuccess={handleLoginSuccess}
            onRegisterClick={() => {
              setMode("register");
              setShowLogin(true);
            }}
          />
        } />
        <Route path="/agents" element={<AgentsPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} />} />
        <Route path="/flow" element={<FlowPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} />} />
        <Route path="/blogs" element={<BlogsPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} client={client} />} />
        <Route path="/contact" element={<Contact baseUrl={baseUrl} />} />
        <Route path="/personvern" element={<PersonvernPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} />} />
        <Route path="/vilkar" element={<VilkarPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} />} />
        <Route path="/streaming-now" element={<EventsPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} />} />
        <Route path="/upcoming-events" element={<EventsPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} />} />
        <Route path="/payment-methods" element={<PaymentMethodsPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} />} />
        <Route path="/vipps-booking" element={<VippsBookingPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} client={client} />} />
        <Route path="/video-service" element={<VideoServicePage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} client={client} />} />
        <Route path="/vilkar-booking-cancel" element={<VilkarBookingCancelPage baseUrl={baseUrl} currentUser={currentUser} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} onLogout={handleLogout} />} />
        <Route path="/agent/:agentId" element={<AgentProfilePage currentUser={currentUser} onLogout={handleLogout} baseUrl={baseUrl} onLoginClick={() => setShowLogin(true)} onLoginSuccess={handleLoginSuccess} />} />
        <Route path="/customer/dashboard" element={
          <CustomerDashboard currentUser={currentUser} onLogout={handleLogout} baseUrl={baseUrl} />
        } />
        <Route path="/customer/one-to-one-audio-call/:callId" element={<VcomAudioCall baseUrl={baseUrl} currentUser={currentUser} />} />
        <Route path="/customer/one-to-one-video-call/:callId" element={<VcomVideoCall baseUrl={baseUrl} currentUser={currentUser} />} />
        <Route path="/customer/join-booking-call/:eventKey" element={<VcomBookingCall baseUrl={baseUrl} currentUser={currentUser} />} />
        <Route path="/customer/join-broadcast/:customer/:broadcastId" element={<JoinBroadcastCustomer baseUrl={baseUrl} currentUser={currentUser} />} />
        <Route path="/agent/one-to-one-audio-call/:callId" element={<VcomAgentAudioCall baseUrl={baseUrl} currentUser={currentUser} />} />
        <Route path="/agent/one-to-one-video-call/:callId" element={<VcomAgentVideoCall baseUrl={baseUrl} currentUser={currentUser} />} />
        <Route path="/agent/join-booking-call/:eventKey" element={<VcomAgentBookingCall baseUrl={baseUrl} currentUser={currentUser} />} />
        <Route path="/agent/broadcast/:broadcastId" element={<JoinBroadcastAgent baseUrl={baseUrl} currentUser={currentUser} />} />
        <Route path="/guest/broadcast/:guestName/:broadcastId" element={<JoinBroadcastGuest baseUrl={baseUrl} currentUser={currentUser} />} />
        <Route path="/agent/dashboard" element={
          <AgentDashboard currentUser={currentUser} onLogout={handleLogout} baseUrl={baseUrl} />
        } />
        <Route path="/advertisment_admin/dashboard" element={
          <AdvertismentAdminDashboard />
        } />
        <Route path="/support_admin/dashboard" element={
          currentUser ? (
            <ClientDashboard
              currentUser={currentUser}
              onLogout={handleLogout}
              baseUrl={baseUrl}
              onRegisterClick={() => {
                setMode("register");
                setShowLogin(true);
              }}
              onLoginClick={() => { setMode("login"); setShowLogin(true) }}
              onLoginSuccess={handleLoginSuccess}
            />
          ) : (
            <Navigate to="/" replace />
          )
        } />
        <Route path="/successCheckoutpayment_broadscast" element={<BroadcastCardApproved baseUrl={baseUrl} onLoginSuccess={handleLoginSuccess} currentUser={currentUser} />} />
        <Route path="/successBookingCheckoutpayment_agent" element={<BookingCardApproved baseUrl={baseUrl} onLoginSuccess={handleLoginSuccess} currentUser={currentUser} />} />
        <Route path="/successCheckoutWalletCreditStripe" element={<SuccessCheckout baseUrl={baseUrl} />} />
        <Route path="/agent-reauth-stripe" element={<AgentStripeReauthHandler baseUrl={baseUrl} />} />
        <Route path="/agent-kyc-success" element={<AgentKYCSuccess baseUrl={baseUrl} />} />
        <Route path="/wallet-kyc-success" element={<KYCSuccess baseUrl={baseUrl} />} />
        <Route path="/login-approved" element={<LoginApproved baseUrl={baseUrl} onLoginSuccess={handleLoginSuccess} />} />
        <Route path="/card-approved" element={<CardApproved baseUrl={baseUrl} onLoginSuccess={handleLoginSuccess} currentUser={currentUser} />} />
      </Routes>

      <LoginModal
        show={showLogin}
        onClose={() => setShowLogin(false)}
        onLoginSuccess={handleLoginSuccess}
        baseUrl={baseUrl}
        mode={mode}
        setMode={setMode}
      />
      {
        firstLoginUser && (
          <PasswordModal
            show={showPasswordModal}
            onClose={() => setShowPasswordModal(false)}
            baseUrl={baseUrl}
            currentUser={firstLoginUser}
          />
        )
      }
    </>
  );
}

export default App;
